import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import { NIP19Page } from "./pages/NIP19Page";
import { TorchDetail } from "./pages/TorchDetail";
import { PassTorch } from "./pages/PassTorch";
import { TorchPreview } from "./pages/TorchPreview";
import { CreateTorch } from "./pages/CreateTorch";
import { MyTorches } from "./pages/MyTorches";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/torch/:naddr" element={<TorchDetail />} />
        <Route path="/pass/:naddr" element={<PassTorch />} />
        <Route path="/preview" element={<TorchPreview />} />
        <Route path="/create" element={<CreateTorch />} />
        <Route path="/my-torches" element={<MyTorches />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;
